/* eslint-disable */
import ko from 'knockout';
var ViewModel = function (data) {
  this.mobileUrlVisible = ko.observable(data.isFinal && !data.isMobilePreferred);
  this.urlOptionsVisible = ko.observable(data.isFinal && data.urlOptionsEnabled);
  this.showTitles = ko.observable(data.showTitles);
  this.editMode = ko.observable(false);
  this.errorMessages = ko.observableArray();
  this.landingPageUrlErrorMessages = ko.observableArray();
  this.showUpgradeWarning = ko.observable(false);
};
export default ViewModel;

